import { render, staticRenderFns } from "./application.vue?vue&type=template&id=4c19c908&"
import script from "./application.ts?vue&type=script&lang=ts&"
export * from "./application.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports